import { render, staticRenderFns } from "./CadastrarMedicoExame.vue?vue&type=template&id=dd233dce&scoped=true"
import script from "./CadastrarMedicoExame.vue?vue&type=script&lang=js"
export * from "./CadastrarMedicoExame.vue?vue&type=script&lang=js"
import style0 from "./CadastrarMedicoExame.vue?vue&type=style&index=0&id=dd233dce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd233dce",
  null
  
)

export default component.exports